import React, { useState ,useEffect} from 'react';
import { Table, Input, Button, Form, InputNumber, message } from 'antd';
import { getDatasheetTableData } from '../../../Services/LocomotiveServices';
import { useLocation } from 'react-router-dom';
import { EditOutlined, PlusOneOutlined } from '@mui/icons-material';
import roleManager from '../../../Components/roles';
// import { useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { errorMessage } from '../../../helpers';
import { ErrorMessages } from '../../../helpers/textValidation';

const EditableTable = ({ tableData, reload, handleDataSheetTable, params ,modalOpen, editingKey, setEditingKey }) => {
   
  const [data, setData] = useState([]);
  const [description, setDescription] = useState('');
  const [originalValues, setOriginalValues] = useState({});
  // const params = useRef(true);

  const equipTypeIdArray = Array.isArray(tableData?.EquipTyp?.EquipTypeId)
    ? tableData?.EquipTyp?.EquipTypeId
    : [tableData?.EquipTyp?.EquipTypeId];

  const newData = equipTypeIdArray.map((equipType) => ({
    id: equipType?.id,
    key: equipType?.name,
    description: equipType?.name,
    type: 'Yes',
    Brake_SYS: '...',
    newDescription: Array.isArray(equipType?.EquipDatasheetId) && equipType?.EquipDatasheetId.length
      ? equipType?.EquipDatasheetId[0]?.Description
      : '',
  }));
  if (!params.current)
    newData.sort((a, b) => {
      if (a.newDescription && !b.newDescription) {
        return -1;
      } else if (!a.newDescription && b.newDescription) {
        return 1;
      } else {
        return 0;
      }
    });
    
  const isEditing = (record) => record.key === editingKey;
  const { state } = useLocation()
  const id = state?.data?.id
   

  const columns = [
    {
      title: <span style={{ fontSize: '19px', fontWeight: 'bold' }}>Description</span>,
      dataIndex: 'description',
      key: 'description',
      render: (text) => <span style={{ fontSize: '19px' }}>{text}</span>,

    },
    {
      dataIndex: 'newDescription',
      key: 'newDescription',
      editable: true,
      render: (text) => <span style={{ fontSize: '19px' }}>{text}</span>,


    },

    {

      title: roleManager("locomotive", "lookupEdit", "DataSheet") && tableData?.EquipTypId !== null ? <span style={{ fontSize: '19px', }}>Edit</span> : null,
      dataIndex: 'edit',
      render: (_, record, index) => {
        const editable = isEditing(record);
        //  
        const canEdit = roleManager("locomotive", "lookupEdit", "DataSheet");

        return (
          canEdit && tableData?.EquipTypId !== null ? (
            editable ? (
              <span>
                <Button
                  type="link"
                  onClick={() => save(record)}
                >
                  Save
                </Button>
                <Button type="link" onClick={cancel}>
                  Cancel
                </Button>
              </span>
            ) : (
              <Button style={{ paddingLeft: '1px' }} type="link" onClick={() => edit(record.key)}>
                <EditOutlined />
              </Button>
            )
          ) : null
        );
      },
    }

  ];
  useEffect(() => {
    return () => {
      setEditingKey('');
    };
  }, []);

  useEffect(() => {
    if (!modalOpen) {
      setEditingKey('');
    }
  }, [modalOpen]);


  const edit = (key) => {
    // Store the original values before editing
    setEditingKey(key);
    const originalRecord = newData.find((item) => item.key === key);
    setOriginalValues({ ...originalValues, [key]: originalRecord.newDescription });

  };


  const save = async (record) => {
    try {
       
      const newDescriptionValue = record?.newDescription;
      if (!newDescriptionValue.trim()) {
        message.error('New description is empty. kindly fill it ');
        
        return;
      }
  


      const response = await getDatasheetTableData(
        id,
        record?.id,
        {
          Description: newDescriptionValue,
        }
      );

       
      await reload()
      setEditingKey('');

    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  // ... (remaining code)


  const cancel = () => {
    // window.location.reload()
    setEditingKey('');
  };

  const handleTableChange = (pagination, filters, sorter) => {
  };

  const mergedColumns = columns?.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });



  return (
    <div>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        scroll={{
          y: 500,
          // x: 240,
        }}
        style={{ marginBottom: '-5px' }}
        dataSource={newData}
        columns={mergedColumns}
        rowClassName=""
        onChange={handleTableChange}
        pagination={false}
      />
      {roleManager("locomotive", "lookupEdit", "DataSheet") ?
        <Button
          style={{
            fontSize: '20px',
            paddingTop: '10px',
            paddingBottom: '10px',
            background: '#2863ad',
            color: 'white',
            marginTop: '25px',
            display: params.current == true ? 'block' : 'none',
            height: '120%',
            borderRadius: '13px'

          }}
          onClick={handleDataSheetTable}><AddIcon style={{ fontSize: '25px', paddingTop: '6px' }} />Add Locomotive item </Button> : " "}
    </div>
  );
};

const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children }) => {
  const [originalValues, setOriginalValues] = useState({});

  const defaultValue = record?.key in originalValues ? originalValues[record?.key] : record?.newDescription;
  const handleInputChange = (value) => {
    // Update the correct property based on dataIndex
    if (dataIndex === 'newDescription') {
      record.newDescription = value;
    } else {
      record.description = value;
    }
  };


  return (
    <td style={{ padding: '-2px' }}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0, padding: '16px 1px' }}
          rules={[
            {
              validator: (_, value) => {
                if (!value || value.trim() === '') {
                  return Promise.reject(`Please input ${title}!`);
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          {inputType === 'text' ? (
            <Input defaultValue={defaultValue} onChange={({ target: { value } }) => handleInputChange(value)} maxLength={60} style={{ fontSize: '18px' }} required />
          ) : (
            <InputNumber defaultValue={defaultValue} onChange={(value) => handleInputChange(value)} required />
          )}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableTable;
